export default "__VITE_ASSET__C30HW2Su__"